import { createContext, useContext } from "react";

/** Lets a field submit its form from the keyboard (Android "go" key). The web uses the <form>. */
export const FormContext = createContext<{ submit: () => void } | null>(null);

export const useFormSubmit = () => useContext(FormContext)?.submit;
